export default __webpack_public_path__ + "static/media/1.f05c704a.jpg";